import { SUPER_CHAT } from "../constants/gameConstant";
import { QUESTIONS } from "../constants/questionConstant";

// コメントBot
// @param {Object} comment - コメントを管理するオブジェクト
// @param {Array} users - ユーザー名のリスト
// @param {Array} comments - コメントのリスト
// @param {Array} prices - スーパーチャットの値段のリスト
// @param {number} minInterval - コメントの追加間隔の最小値
// @param {number} maxInterval - コメントの追加間隔の最大値
const CommentBot = ({ comment, users, comments, prices, minInterval, maxInterval }) => {
    // ランダムな遅延時間を設定
    const randomDelay = Math.random() * (maxInterval - minInterval) + minInterval;
    setTimeout(() => {
        // ランダムなコメントを投稿
        const userIndex = Math.floor(Math.random() * users.length);
        const commentIndex = Math.floor(Math.random() * comments.length);
        const priceIndex = Math.floor(Math.random() * prices.length);
        comment?.addComment(users[userIndex], comments[commentIndex], prices[priceIndex]);

        // 次の実行を再設定
        CommentBot({ comment, users, comments, prices, minInterval, maxInterval });
    }, randomDelay);
};

// オープニング用のコメントBot
// @param {Object} comment - コメントを管理するオブジェクト
// [仕様]
// ・コメントの追加間隔は0.25秒から1.0秒のランダム
// ・コメントのユーザー名はランダムに選択
// ・コメントの内容はランダムに選択
// ・スーパーチャットはしない
const OpeningCommentBot = ({ comment }) => {
    const minInterval = 250;
    const maxInterval = 1000;

    const users = [
        '空色の旅人',
        'もちもち猫',
        '晴れた日和',
        '蒼い響き',
        'ピクセルの世界',
        'ねこの足跡',
        'オーロラの心',
        '天才',
        '虹色の鈴',
        '月夜のひげ',
        '星空のこだま',
        '雲のかけら',
        '結晶の花',
        'ITの魔法使い',
        '楓の光',
        '通りすがり',
        'プログラマのたまご',
        '黄昏のエンジニア',
        '琥珀の流れ',
    ];
    const comments = [
        'こんたかた！',
        'こんたかた～',
        'はじめまして',
        'こんにちは',
        '初見です',
        '配信待ってました',
        'わくわく',
        'こんたかた',
    ];
    const prices = [
        0
    ];
    CommentBot({ comment, users, comments, prices, minInterval, maxInterval });
};

// ゲーム中の汎用コメントBot
// @param {Object} comment - コメントを管理するオブジェクト
// [仕様]
// ・コメントの追加間隔は2.0秒から3.0秒のランダム
// ・コメントのユーザー名はランダムに選択
// ・コメントの内容はランダムに選択
// ・スーパーチャットの金額はランダムに選択(最大1000円)
const GameCommentBot = ({ comment }) => {
    const minInterval = 2000;
    const maxInterval = 3000;

    const users = [
        '空色の旅人',
        'もちもち猫',
        '晴れた日和',
        '蒼い響き',
        'ピクセルの世界',
        'ねこの足跡',
        '雲のかけら',
        '結晶の花',
        'ITの魔法使い',
        '楓の光',
        '通りすがり',
        'プログラマのたまご',
        '黄昏のエンジニア',
        '琥珀の流れ',
        '応援係'
    ];
    const comments = [
        'こんたかた',
        'こんたかた',
        'はじめまして',
        '今、なにしてる？',
        'ぬるぽ',
        '( ..)φメモメモ',
        'お腹すいた',
        '応援してます',
        '待ってましたー',
        '音量ちょうどいいです',
        '( *´艸｀)',
        'ないすぱ',
        '８８８８８８８８８',
    ];
    const prices = [
        0, 0, 0, 0, 0, 0, 0, 200, 200, 500, 1000
    ];
    CommentBot({ comment, users, comments, prices, minInterval, maxInterval });
};

// 挨拶コメントかどうかを判定する関数
// @param {Object} question - 問題オブジェクト
// @return {boolean} - 挨拶コメントかどうか
const IsGreetings = (question) => {
    return (question?.ID == 1 || question?.ID == 2 || question?.ID == 6 || question?.ID == 10) ? true : false;
};

// 回答コメントBot
// @param {Object} comment - コメントを管理するオブジェクト
// @param {Object} question - 問題オブジェクト
// [仕様]
// 正解コメントを赤スパ投稿
const AnswerCommentBot = ({ comment, question }) => {
    let message = IsGreetings(question) ? question.ANSWER_JP : "「" + question.ANSWER_JP + "」ですね！";
    comment?.addComment(SUPER_CHAT.CAST2_NAME,
        message,
        SUPER_CHAT.PRICE_LEVEL_7,
        SUPER_CHAT.CAST2_IMAGE_NAME);
};

// 問題事のヒントコメントBot
// @param {Object} comment - コメントを管理するオブジェクト
// @param {Object} question - 問題オブジェクト
// @param {int} time - 時間
// [仕様]
// 問題番号と経過時間に応じてヒントコメントを追加
const GameHintCommentBot = ({ comment, question, time }) => {
    let hintComment = null;
    let castIndex = 0;
    switch (question?.ID) {
        case 1:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_6: hintComment = "待ってました！！"; break;
                case SUPER_CHAT.TIME_LEVEL_4: hintComment = "よっ！待ってました！"; castIndex = 1; break;
                case SUPER_CHAT.TIME_LEVEL_3: hintComment = "こんたかた！"; break;
            }
            break;
        case 2:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_6: hintComment = "僕も挑戦します"; break;
                case SUPER_CHAT.TIME_LEVEL_3: hintComment = "今日はどんな問題が出るか楽しみ！"; castIndex = 1; break;
            }
            break;
        case 3:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_7: hintComment = "カタカナだけだったような"; break;
                case SUPER_CHAT.TIME_LEVEL_5: hintComment = "「道」というより「乗る」ほうかな"; castIndex = 1; break;
                case SUPER_CHAT.TIME_LEVEL_3: hintComment = "カタカナの「イ」が答えに入ってたはず"; break;
            }
            break;
        case 4:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_7: hintComment = "何かとCキーだったような"; break;
                case SUPER_CHAT.TIME_LEVEL_4: hintComment = "切り取りとか貼り付けの仲間だったはず"; break;
            }
            break;
        case 5:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_7: hintComment = "（）の中に色々書いてたかも"; break;
                case SUPER_CHAT.TIME_LEVEL_4: hintComment = "（String[] ○○○○）だったはず"; castIndex = 1; break;
            }
        case 6:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_7: hintComment = "身体のストレッチも忘れずに！"; break;
                case SUPER_CHAT.TIME_LEVEL_4: hintComment = " ^^) _旦~~"; castIndex = 1; break;
            }
            break;
        case 7:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_7: hintComment = "ITの資格はどれも難しいから取るのむずしいよ"; break;
                case SUPER_CHAT.TIME_LEVEL_4: hintComment = "ひとつだけなんか仲間はずれな単語がありますね"; castIndex = 1; break;
            }
            break;
        case 8:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_7: hintComment = "総称そこまで長くなかったような気がする"; break;
                case SUPER_CHAT.TIME_LEVEL_5: hintComment = "AWSは安全や防護ってより提供の意味だね"; castIndex = 1; break;
                case SUPER_CHAT.TIME_LEVEL_3: hintComment = "仮想サーバーやストレージ、データベースなどのサービスを提供で「世界」って単語意味あるかな"; break;
            }
            break;
        case 9:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_6: hintComment = "メールアドレスは h_takata ですが…実は…"; break;
                case SUPER_CHAT.TIME_LEVEL_4: hintComment = "ヒュージのスペルが勘違いしがちですね"; castIndex = 1; break;
            }
            break;
        case 10:
            switch (time) {
                case SUPER_CHAT.TIME_LEVEL_6: hintComment = "おつたかです"; break;
                case SUPER_CHAT.TIME_LEVEL_4: hintComment = "お疲れさまでしたー"; castIndex = 1; break;
                case SUPER_CHAT.TIME_LEVEL_1: hintComment = "またきまーす"; break;
            }
            break;
    }

    if (hintComment != null) {
        comment?.addComment(
            [SUPER_CHAT.CAST1_NAME, SUPER_CHAT.CAST2_NAME][castIndex],
            hintComment,
            (time >= SUPER_CHAT.TIME_LEVEL_4) ? SUPER_CHAT.PRICE_LEVEL_5 : SUPER_CHAT.PRICE_LEVEL_6,
            [SUPER_CHAT.CAST1_IMAGE_NAME, SUPER_CHAT.CAST2_IMAGE_NAME][castIndex]);
    }
}

export { OpeningCommentBot, GameCommentBot, GameHintCommentBot, AnswerCommentBot };
